import React from 'react';

import bgbackground from '../../../assets/facebookForm_.png';
import { Container } from '../Page2/styles';
import { IMG } from './styles';
export function Page3() {
  return <IMG src={bgbackground} />;
}
